import Vue from 'vue'
import vuetify from './plugins/vuetify'
import { VApp } from "vuetify/lib";
import axios from "axios";
import vueCustomElement from 'vue-custom-element'
import CcresVisu from "./components/CcresVisu"

// Vue.prototype.$prodPrefix = "http://localhost:8080/"

Vue.use(vueCustomElement);
Vue.use(axios);



Vue.customElement('ccres-visu', {
  vuetify: vuetify,
  components: { VApp, CcresVisu },
  template: `<v-app id='app'><ccres-visu></ccres-visu></v-app>`
})




// vue-cli-service build --target lib --name CCRESVisu src/main.production.js